import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import cn from 'classnames';
import { TiLocation } from 'react-icons/ti';
import GoogleMap from './google_map';
import styles from './style.scss';

function GeoMap({ event, settings, className = '', showGoogleMap }) {
  if (event.get('venue').isEmpty()) {
    return <span />;
  }
  const latitude = event.getIn(['venue', 'latitude']) || event.getIn(['venue', 'address', 'latitude']);
  const longitude = event.getIn(['venue', 'longitude']) || event.getIn(['venue', 'address', 'longitude']);
  if (!latitude || !longitude) return <span />;
  return (
    <div className={cn(styles.map, className, 'location')}>
      {showGoogleMap ? (
        <GoogleMap latitude={+latitude} longitude={+longitude} />
      ) : (
        <a href={`http://maps.google.com/?q=${latitude},${longitude}&zoom=10`} className="hint--bottom" aria-label={settings.get('mapText')}>
          <TiLocation size="20" className="iconPosition location" />
        </a>
      )}
    </div>
  );
}

const propTypes = {
  event: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  className: PropTypes.string,
  showGoogleMap: PropTypes.bool,
};

GeoMap.propTypes = propTypes;

export default GeoMap;
